import shipMessages from './shipMessages';
import injectMessage from './injectMessage';

const availabilityMessageFormatter = (availabilityMessage) => {
  let availabilityMessageFormatted = availabilityMessage && !availabilityMessage.endsWith(':') ? `${availabilityMessage}:` : availabilityMessage; // Add colon if not present
  availabilityMessageFormatted = availabilityMessageFormatted.toLowerCase();
  return availabilityMessageFormatted.charAt(0).toUpperCase() + availabilityMessageFormatted.slice(1);
};

const generateShipMessage = (data, zipCode, isInternationalShip, isEGiftCard, isParcelShipping, isFurnitureShipping) => {
  let disabled = true;
  let label = '';
  let shipText = '';
  let shipFromSeller = '';
  let sddLabel = '';
  let shipAvailable = '';
  if (data.productInfo) {
    const {
      available,
      message,
      availabilityMessage,
      sddAvailability,
      sellerName,
      marketplaceItemFlag,
      orderType,
    } = data.productInfo;

    const availabilityMessageFormatted = (orderType.toLowerCase() === 'drop') ? 'Direct from vendor:' : availabilityMessageFormatter(availabilityMessage);

    const sellerNameFormatted = sellerName?.charAt(0)?.toUpperCase() + sellerName?.slice(1, 30);
    shipFromSeller = (marketplaceItemFlag && sellerName && available) ? `Sold and shipped by ${sellerNameFormatted}` : '';
    shipAvailable = available;

    if (!available && zipCode && !isInternationalShip) {
      shipText = `Not available for shipping to ${zipCode}`;
      label = '';
    } else if (!available) {
      shipText = '';
      label = '';
    } else if (isEGiftCard && data.eGiftCardInfo) {
      const {
        eGiftCardEmailId,
        eGiftCardShipHours,
      } = data.eGiftCardInfo;
      label += `${availabilityMessageFormatted} `;
      label += injectMessage(shipMessages.eGiftCard, { eGiftCardEmailId, eGiftCardShipHours });
    } else if (isFurnitureShipping) {
      label += `${message}`;
    } else if (isParcelShipping) {
      shipText = `Ship to ${zipCode}`;
      label += `${message}`;
    } else if (isInternationalShip) {
      label += `${availabilityMessageFormatted} ${message}`;
    } else if (message && zipCode) {
      shipText = `Ship to ${zipCode}`;
      label += availabilityMessageFormatted ? `${availabilityMessageFormatted} ${message}` : message;
    }

    disabled = !available || (!isInternationalShip && !zipCode);
    const deliveryDayLowerCase = data.storeInfo?.deliveryMessage?.toLowerCase?.();
    const deliveryToday = deliveryDayLowerCase === 'same-day delivery';
    const deliveryTomorrow = deliveryDayLowerCase === 'next-day delivery';

    if (sddAvailability && !isInternationalShip && !isEGiftCard && zipCode && available && (deliveryToday || deliveryTomorrow)) {
      sddLabel = (deliveryToday && data.storeInfo.orderCutoffTime)
        ? injectMessage(shipMessages.sddEligible, { sddCutoffTime: data.storeInfo.orderCutoffTime })
        : injectMessage(shipMessages.nddEligible);
    }
  }
  label = label?.trim();
  shipFromSeller = shipFromSeller?.trim();
  sddLabel = sddLabel?.trim();

  return {
    shipText, label, value: 'ShipIt', disabled, shipFromSeller, sddLabel, shipAvailable,
  };
};

export default generateShipMessage;
